import { QubictronUrlBuilder } from "@qubictron/url/client";
import axios from "axios";
import { ExceptionsQueryParams } from "./query.types";
import { ExceptionsResponseDTO } from "./response.types";
import { injectAuthHeader, injectDataInterceptor } from "shared/api/utils/api.utils";

const EXCEPTIONS_API_URL = new QubictronUrlBuilder().appendPathname("tracking-system/exceptions").build();

const exceptionsRequestInstance = axios.create();
exceptionsRequestInstance.defaults.baseURL = EXCEPTIONS_API_URL;
injectDataInterceptor(exceptionsRequestInstance);
injectAuthHeader(exceptionsRequestInstance);

class ExceptionsService {
  public search(params: ExceptionsQueryParams, signal?: AbortSignal): Promise<ExceptionsResponseDTO> {
    return exceptionsRequestInstance.get("", { params, ...(signal ? { signal } : {}) });
  }
}

const exceptionsService = new ExceptionsService();

export { exceptionsService };
